<template>
  <WorkflowDesigner ref="workflowDesigner" />
</template>

<script>
import WorkflowDesigner from './workflowDesigner2.vue'

export default {
  components: { WorkflowDesigner },
  beforeRouteLeave (to, from, next) {
    const workflowDesigner = this.$refs.workflowDesigner

    if (workflowDesigner?.confirmRouteLeave) {
      workflowDesigner.confirmRouteLeave(next)
      return
    }

    next()
  }
}
</script>
